import React, { useState, useEffect } from 'react'
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PaletteIcon from '@material-ui/icons/Palette';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import HistoryIcon from '@material-ui/icons/History';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const faqData = [
  {
    question: 'Is ledscroller.com free to use?',
    answer: 'Yes, our basic features are free for everyone.'
  },
  {
    question: 'Do you collect personal data?',
    answer: 'No, we respect your privacy and do not collect or share personal information.'
  },
  {
    question: 'Can I use the LED scroller for commercial purposes?',
    answer: 'Absolutely! Our tool is perfect for shops, events, and more.'
  },
  {
    question: 'How do I contact support?',
    answer: 'Email us at usercontactcare@gmail.com.'
  }
];

const features = [
  { icon: <PaletteIcon style={{ fontSize: '2.2rem', color: '#00eaff' }} />, title: 'Customizable Text', desc: 'Change color, speed, font, and more.' },
  { icon: <CheckCircleIcon style={{ fontSize: '2.2rem', color: '#00eaff' }} />, title: 'Pre-made Templates', desc: 'Quickly set up banners with ready designs.' },
  { icon: <SmartphoneIcon style={{ fontSize: '2.2rem', color: '#00eaff' }} />, title: 'Mobile Friendly', desc: 'Works seamlessly on all devices.' },
  { icon: <HistoryIcon style={{ fontSize: '2.2rem', color: '#00eaff' }} />, title: 'Message History', desc: 'Save and reuse your favorite messages.' },
  { icon: <FullscreenIcon style={{ fontSize: '2.2rem', color: '#00eaff' }} />, title: 'Full-Screen Mode', desc: 'Perfect for events and presentations.' }
];

const guides = [
  { step: 1, title: 'Getting Started', desc: 'Enter your message, choose your colors, and press play to see your LED scroller in action.' },
  { step: 2, title: 'Customizing Your Display', desc: 'Use the settings to adjust speed, font size, and background color for maximum impact.' },
  { step: 3, title: 'Saving & Sharing', desc: 'Save your favorite messages and share them with friends or colleagues via social media or direct link.' }
];

const About = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'about_page_view', {
        event_category: 'About',
        event_label: 'About Us Page'
      });
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>About Us | LED Scroller</title>
        <meta name="description" content="Learn about LED Scroller, our mission, vision, company history, and features. Discover why we are the leading platform for digital signage solutions." />
        <meta property="og:title" content="About Us | LED Scroller" />
        <meta property="og:description" content="Learn about LED Scroller, our mission, vision, company history, and features. Discover why we are the leading platform for digital signage solutions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ledscroller.com/about" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "LED Scroller",
            "url": "https://ledscroller.com/about",
            "logo": "https://ledscroller.com/logo192.png",
            "contactPoint": [{
              "@type": "ContactPoint",
              "email": "usercontactcare@gmail.com",
              "contactType": "customer support"
            }],
            "sameAs": [
              "https://facebook.com",
              "https://twitter.com",
              "https://instagram.com",
              "https://linkedin.com"
            ]
          }
        `}</script>
      </Helmet>
      <div className='container'>
        <div className='row'>
          <div className='commanSmallFontHeading col-12 text-left containSection'>About ledscroller.com</div>
          <div className='col-12 containSection'>
            <h2>Who We Are</h2>
            <p>Ledscroller.com is dedicated to providing innovative, easy-to-use LED text scroller tools for businesses, events, and personal use. Our mission is to make digital signage accessible and effective for everyone.</p>
            <div style={{marginTop: '1rem'}}>
              <Link to="/blog">Read our Blog</Link> | <Link to="/contact">Contact Us</Link>
            </div>
          </div>
          <div className='col-12 containSection'>
            <h2>Our Mission</h2>
            <p>To empower users with simple, powerful tools for creating eye-catching LED displays and digital signs, enhancing communication and engagement everywhere.</p>
            <h2>Our Vision</h2>
            <p>To be the leading platform for digital signage solutions, inspiring creativity and innovation in visual communication worldwide.</p>
          </div>
          <div className='col-12 containSection'>
            <h2>Company History</h2>
            <p>Founded in 2022, ledscroller.com started as a small project to help local businesses display messages more effectively. Today, we serve thousands of users globally, constantly improving our platform based on user feedback and technological advancements.</p>
          </div>
          {/* <div className='col-12 containSection'>
              <h2>Meet the Team</h2>
              <ul>
                  <li><strong>Akash Sharma</strong> – Founder & Lead Developer</li>
                  <li><strong>Priya Verma</strong> – UI/UX Designer</li>
                  <li><strong>Rahul Singh</strong> – Marketing & Community Manager</li>
              </ul>
          </div> */}
          <div className='col-12 containSection'>
            <h2>Application Features</h2>
            <div className='features-grid'>
              {features.map((f, i) => (
                <div className='feature-card' key={i}>
                  <div className='feature-icon'>{f.icon}</div>
                  <div className='feature-title'>{f.title}</div>
                  <div className='feature-desc'>{f.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div className='col-12 containSection'>
            <h2>User Guides & Tutorials</h2>
            <div className='guides-grid'>
              {guides.map((g, i) => (
                <div className='guide-card' key={i}>
                  <div className='guide-step'>Step {g.step}</div>
                  <div className='guide-title'>{g.title}</div>
                  <div className='guide-desc'>{g.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div className='col-12 containSection'>
            <h2>Frequently Asked Questions (FAQ)</h2>
            <div className='faq-accordion'>
              {faqData.map((item, idx) => (
                <div className='faq-item' key={idx}>
                  <button className='faq-question' onClick={() => setOpenFAQ(openFAQ === idx ? null : idx)}>
                    <span>{item.question}</span>
                    {openFAQ === idx ? <RemoveIcon style={{ color: '#00eaff' }} /> : <AddIcon style={{ color: '#00eaff' }} />}
                  </button>
                  <div className={`faq-answer${openFAQ === idx ? ' open' : ''}`}>{openFAQ === idx && <div>{item.answer}</div>}</div>
                </div>
              ))}
            </div>
          </div>
          <div className='col-12 containSection'>
            <h2>Privacy Policy</h2>
            <p>We will not use or share your information with anyone except as described in this Privacy Policy. We use your personal information for providing and improving Sign Board : Text Animation App. By using Sign Board : Text Animation App, you agree to the collection and use of your information in accordance with this policy.</p>
            <h3>Log Data</h3>
            <p>We collect information that your browser sends whenever you visit Sign Board : Text Animation App (“Log Data”). This Log Data may include information such as your computer's Internet Protocol (“IP”) address, browser type, pages visited, and other statistics. We use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of ledscroller.com</p>
          </div>
          <div className='col-12 containSection'>
            <h2>Contact Us</h2>
            <p>Please Contact Us: <a href="mailto:usercontactcare@gmail.com">usercontactcare@gmail.com</a></p>
          </div>
        </div>
      </div>
      <style>{`
        .containSection{
          padding-bottom: 25px;   
        }
        .titleSection{
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .features-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          margin-bottom: 2rem;
        }
        .feature-card {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          padding: 1.5rem 1.2rem;
          min-width: 180px;
          flex: 1 1 180px;
          text-align: center;
          color: #b0eaff;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }
        .feature-icon {
          font-size: 2.2rem;
          color: #00eaff;
          margin-bottom: 0.7rem;
        }
        .feature-title {
          font-weight: 600;
          font-size: 1.1rem;
          margin-bottom: 0.3rem;
          color: #fff;
        }
        .feature-desc {
          font-size: 0.98rem;
          color: #b0eaff;
        }
        .guides-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          margin-bottom: 2rem;
        }
        .guide-card {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          padding: 1.2rem 1rem;
          min-width: 200px;
          flex: 1 1 200px;
          color: #fff;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }
        .guide-step {
          font-size: 1.1rem;
          color: #00eaff;
          font-weight: 600;
          margin-bottom: 0.3rem;
        }
        .guide-title {
          font-weight: 600;
          font-size: 1.05rem;
          margin-bottom: 0.2rem;
        }
        .guide-desc {
          font-size: 0.97rem;
          color: #b0eaff;
        }
        .faq-accordion {
          margin-top: 1.5rem;
        }
        .faq-item {
          border-bottom: 1px solid #222;
          margin:15px 0px;
        }
        .faq-question {
          width: 100%;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          border: none;
          outline: none;
          color: #fff;
          font-size: 1.08rem;
          font-weight: 500;
          text-align: left;
          padding: 1.1rem 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          transition: color 0.2s;
        }
        .faq-question:hover {
          color: #00eaff;
        }
        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1);
          color: #b0eaff;
          font-size: 1rem;
        }
        .faq-answer.open {
          max-height: 200px;
          padding: 1rem 15px;
        }
      `}</style>
    </>
  )
}

export default About